import React from 'react';
import {Outlet} from "react-router-dom";
import {AuthService} from "../../service/AuthService";
import {Forbidden} from "../../components/Forbidden";

export const Route = () => {
  return (
    <>
      { !AuthService.hasRole('ROLE_PARCOURS') && (
        <Forbidden module="route"/>
      )}
      { AuthService.hasRole('ROLE_PARCOURS') && (
        <Outlet/>
      )}
    </>
  );
}
